import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom'

import { Result, Button } from 'antd'

import './Vmp.less'
import Home from './Home'

export const VmpNotfound: React.FC = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="抱歉，您访问的页面不存在~"
      extra={
        <Button type="primary">
          <Link to="/">Back Home</Link>
        </Button>
      }
      style={{ margin: '5% auto' }}
    />
  )
}

export const VmpNoAuthority: React.FC = () => {
  return (
    <Result
      status="403"
      title="401"
      subTitle="抱歉，您当前还没有获得该页面的访问权限哦~"
      extra={
        <Button type="primary">
          <Link to="/">Back Home</Link>
        </Button>
      }
      style={{ margin: '5% auto' }}
    />
  )
}

export const VmpSeverError: React.FC = () => {
  return (
    <Result
      status="500"
      title="500"
      subTitle="抱歉，发生了点小问题，我们正在抓紧修复中..."
      extra={
        <Button type="primary">
          <Link to="/">回到主页</Link>
        </Button>
      }
      style={{ margin: '5% auto' }}
    />
  )
}

export const VmpNotPublish: React.FC = () => {
  return (
    <Result
      status="warning"
      title="该报告暂未发布"
      extra={
        <Button type="primary">
          <Link to="/">回到主页</Link>
        </Button>
      }
      style={{ margin: '5% auto' }}
    />
  )
}

const Vmp: React.FC = () => {
  return (
    <Switch>
      <Route key={'home'} exact path={['/articles/:articleID(\\d+)', '/']}>
        <Home />
      </Route>
      <Route key={'404'}>
        <VmpNotfound />
      </Route>
    </Switch>
  )
}

export default Vmp
